<span style="vertical-align: middle;font-size: 18px;">
  {{currentTenant?.name}}
</span>
<span>
  <button class="overflow-visible" mat-icon-button [matMenuTriggerFor]="notificationsMenu">
    <mat-icon md-32 matBadgeColor="accent" [matBadge]="tenants?.length">switch_account</mat-icon>
  </button>
</span>
<mat-menu #notificationsMenu="matMenu" [overlapTrigger]="false">
  <span *ngIf="theme === 'dark-theme'; else darkTheme">
    <h4 style="text-align: center;margin: 4px;color: white;">{{currentTenant?.name}}</h4>
  </span>
  <ng-template #darkTheme>
    <span>
      <h4 style="text-align: center;margin: 4px;">{{currentTenant?.name}}</h4>
    </span>
  </ng-template>
  <mat-divider style="margin-top: 8px;margin-bottom: 0px;"></mat-divider>
  <mat-nav-list dense>
    <ng-template let-last="last" ngFor let-item="$implicit" [ngForOf]="tenants">
      <a mat-list-item (click)="switchTenant(item)">
        <div *ngIf="currentTenant?.name === item.name; else notActive">
          <div class="text-with-icon">
            <mat-icon color="primary">account_box</mat-icon>&nbsp;&nbsp;Switch To {{item.name}}
          </div>
        </div>

        <ng-template #notActive>
          <div class="text-with-icon">
            <mat-icon>account_box</mat-icon>&nbsp;&nbsp;Switch To {{item.name}}
          </div>
        </ng-template>
      </a>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-template>
  </mat-nav-list>
</mat-menu>
